var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusCircleSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2212 22.8168C17.744 22.8168 22.2212 18.3396 22.2212 12.8168C22.2212 7.29392 17.744 2.81677 12.2212 2.81677C6.69834 2.81677 2.22119 7.29392 2.22119 12.8168C2.22119 18.3396 6.69834 22.8168 12.2212 22.8168ZM7.72119 11.8168C7.44505 11.8168 7.22119 12.0406 7.22119 12.3168V13.3168C7.22119 13.5929 7.44505 13.8168 7.72119 13.8168H16.7212C16.9973 13.8168 17.2212 13.5929 17.2212 13.3168V12.3168C17.2212 12.0406 16.9973 11.8168 16.7212 11.8168H7.72119Z",
    fill: "#DD1D21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusCircleSolid);
export default __webpack_public_path__ + "static/media/minus-circle-solid.e9ccf969cf0918e74a861f34219fa4a8.svg";
export { ForwardRef as ReactComponent };